import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';


@Injectable({
    providedIn: 'root'
})
export class KeywordTypeService { 
    url='keywordtypes';
    constructor(private http:HttpClient) {}

    getAll(courseid:any){
        return this.http.get<any>(`${environment.apiUrl}/${this.url}?courseid=${courseid}`);
    }
    all(phaseid:any){
        return this.http.get<any>(`${environment.apiUrl}/${this.url}/phase?phaseid=${phaseid}`);
    }
  
    get(id:any){
        return this.http.get<any>(`${environment.apiUrl}/${this.url}/${id}`);
    }

    add(duty:any){
        return this.http.post<any>(`${environment.apiUrl}/${this.url}`,duty);
    }

    update(id:any,duty:any){
        return this.http.put<any>(`${environment.apiUrl}/${this.url}/${id}`,duty);
    }

    delete(id:any){
        return this.http.delete<any>(`${environment.apiUrl}/${this.url}/${id}`);
    }
}